"use client";

import { useEffect, useRef, useState } from "react";

import { getCookie, setCookie } from "cookies-next";

export type DictionaryListIndicator = Record<string, boolean>;

export type UseNewIndicatorReturnType = {
  showIndicator: DictionaryListIndicator;
  onHideIndicator: (route: string) => void;
};

export const useNewIndicator = (
  newRoutes: ReadonlyArray<string> = []
): UseNewIndicatorReturnType => {
  const isNewIndicatorLoaded = useRef(false);
  const [showIndicator, setShowIndicator] = useState<DictionaryListIndicator>(
    {}
  );

  const handleHideIndicator = (route: string) => {
    setCookie(route, true, { maxAge: 60 * 60 * 24 * 365 });
    setShowIndicator((prevIndicator) => {
      return {
        ...prevIndicator,
        [route]: false,
      };
    });
  };

  useEffect(() => {
    if (isNewIndicatorLoaded.current) return;

    const newIndicatorDictionary = newRoutes.reduce<DictionaryListIndicator>(
      (acc, route) => {
        return {
          ...acc,
          [route]: getCookie(route) === undefined,
        };
      },
      {}
    );

    setShowIndicator(newIndicatorDictionary);
    isNewIndicatorLoaded.current = true;
  }, [newRoutes]);

  return {
    showIndicator,
    onHideIndicator: handleHideIndicator,
  };
};

export default useNewIndicator;
